import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useHasCapabilityBool, DOMAIN, PERMISSION } from "@/hooks/useCapabilities";

const tabs = ["all-jobs", "permissions"] as const;
type TabType = (typeof tabs)[number];

export default function JobsTabs() {
  const canManageFacilityRoles = useHasCapabilityBool({
    domain: DOMAIN.FACILITIES,
    permission: PERMISSION.manageFacilityRoles
  });

  const location = useLocation();
  const { facilityId } = useParams();
  const { pathname, search } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();

  const tabOptions: Record<TabType, { label: string; path: string }> = {
    "all-jobs": {
      label: "Jobs",
      path: `/facilities/${facilityId}/jobs/all-jobs`
    },
    permissions: {
      label: "Permissions",
      path: `/facilities/${facilityId}/jobs/permissions`
    }
  };

  const filteredTabItems = Object.entries(tabOptions)
    .filter(([key]) => key === "all-jobs" || (key === "permissions" && canManageFacilityRoles))
    .sort(([keyA], [_keyB]) => {
      if (canManageFacilityRoles) {
        return keyA === "all-jobs" ? -1 : 1;
      }
      return 0;
    })
    .map(([_, tab]) => ({
      label: tab.label,
      active: currentUrl.startsWith(tab.path),
      onClick: () => navigate(`${tab.path}${search}` as Path)
    }));

  return (
    <div>
      <Tabs tabItems={filteredTabItems} />
      <Outlet />
    </div>
  );
}
